<template>
  <el-card>
    <div slot="header">
      <span>Fájlok</span>
      <el-button
        v-if="dialogType !== 'view'"
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="onCreate"
      >
        Új Fájl
      </el-button>
    </div>
    <list
      :files="files"
      :showDialog="showDialog"
      :dialog-type="dialogType"
      @closeDialog="showDialog = false"
      @change="onChange"
      @delete="onDelete"
      @add="onFileCreate"
    />
  </el-card>
</template>

<script>
  import List from './files/List';

  export default {
    components: { List },
    props: ['files', 'dialogType'],
    data() {
      return {
        showDialog: false,
        basicData: {},
        rules: {
          name: [
            {
              required: true,
              message: 'Név megadása kötelező',
              trigger: 'change'
            }
          ],
        }
      };
    },
    computed: {
      products() {
        return this.$store.getters['product/products'];
      },
    },
    watch: {
      product(newVal) {
        this.basicData = Object.assign({}, newVal);
      },
    },
    methods: {
      onCreate() {
        this.fileFormType = 'add';
        this.showDialog = true;
      },
      onFileCreate(files) {
        this.$emit('add', files);
      },
      onChange(files) {
        this.$emit('fileChange', files);
      },
      onDelete(file) {
        this.$emit('fileDelete', file);
      },
      onOpenCreate() {
        this.showDialog = true;
      },
    },
  };
</script>
